import api from '../http-request'
import apiConstants from '../apiConstant'

// [GET] method
export const getAllListCategorySpaceApi = async () =>
    api.get(`${apiConstants.CATEGORY_OF_SPACE.GET_LIST_CATEGORY_SPACE_ALL}`)
export const getListCategorySpaceApi = async () =>
  api.get(`${apiConstants.CATEGORY_OF_SPACE.GET_LIST_CATEGORY_SPACE}`)
export const getDetailCategorySpaceApi = async (id) =>
  api.get(`${apiConstants.CATEGORY_OF_SPACE.GET_DETAIL_CATEGORY_SPACE}/${id}`)
export const getAllListEquipmentAndServicesApi = async () =>
    api.get(`${apiConstants.GET_LIST_EQUIPMENT_SERVICE}`)

// [POST METHOD]
export const createCategorySpaceApi = async (data) =>
  api.post(apiConstants.CATEGORY_OF_SPACE.CREATE_CATEGORY_SPACE, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// [DELETE METHOD]
export const deleteCategorySpaceApi = async (id) =>
  api.delete(`${apiConstants.CATEGORY_OF_SPACE.DELETE_CATEGORY_SPACE}/${id}`)
// [POST METHOD]
export const updateCategorySpaceApi = async (id, data) =>
  api.post(
    `${apiConstants.CATEGORY_OF_SPACE.UPDATE_CATEGORY_SPACE}/${id}`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
